import React from 'react';
import { openInApp } from './openInApp';

const WEB_CREATE_URL = 'https://web.jivebird.com/';

/**
 * "See More + Create a JiveBird" button for viewer.jivebird.com.
 *
 * Phone (real device):
 *   - iOS:     Navigates to Universal Link. If app installed → opens app.
 *              If not installed → Safari smoothly loads the web page. No error dialog.
 *   - Android: Chrome intent with web fallback. Silent fallback if app not installed.
 *
 * Desktop / DevTools mobile inspection:
 *   Opens WEB_CREATE_URL in a new tab, as before.
 */
export default function SeeMoreButton({ onClick, className, style, children }) {
  const handleClick = (e) => {
    e.preventDefault();
    onClick?.();

    // openInApp returns false on desktop → fall through to window.open
    const handled = openInApp('create', { fallbackUrl: WEB_CREATE_URL });
    if (!handled) {
      window.open(WEB_CREATE_URL, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <a
      href={WEB_CREATE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className || "jb-banner-create-btn"}
      style={style}
      onClick={handleClick}
    >
      {children || "Create my FREE JiveBird & See More"}
    </a>
  );
}
